// Collects what any website can see about a visitor without extra permission prompts: browser,
// OS, device type, screen size, language, time zone and where they came from. The server adds the
// IP address itself (it can't be read reliably from the browser).

function detectBrowser(ua) {
  // In-app browsers first: their UAs also contain "Chrome"/"Safari" and would be miscounted.
  if (/FBAN|FBAV|FB_IAB|FB4A/.test(ua)) return "Facebook app";
  if (/Instagram/.test(ua)) return "Instagram app";
  // Order matters: Edge/Opera/Samsung UAs also contain "Chrome", Chrome's also contains "Safari".
  if (/Edg(e|A|iOS)?\//.test(ua)) return "Edge";
  if (/OPR\/|Opera/.test(ua)) return "Opera";
  if (/SamsungBrowser\//.test(ua)) return "Samsung Internet";
  if (/Firefox\/|FxiOS\//.test(ua)) return "Firefox";
  if (/CriOS\/|Chrome\//.test(ua)) return "Chrome";
  if (/Safari\//.test(ua)) return "Safari";
  return "Other";
}

function detectOs(ua) {
  if (/Windows/.test(ua)) return "Windows";
  if (/Android/.test(ua)) return "Android";
  if (/iPhone|iPad|iPod/.test(ua)) return "iOS";
  if (/Mac OS X|Macintosh/.test(ua)) return "macOS";
  if (/CrOS/.test(ua)) return "ChromeOS";
  if (/Linux/.test(ua)) return "Linux";
  return "Other";
}

function detectDeviceType(ua) {
  if (/iPad|Tablet/.test(ua) || (/Android/.test(ua) && !/Mobile/.test(ua))) return "tablet";
  if (/Mobi|iPhone|iPod|Android/.test(ua)) return "mobile";
  return "desktop";
}

// Only the origin+path of an external referrer is useful (and avoids collecting query strings);
// our own pages aren't a "source" so they're dropped.
function getExternalReferrer() {
  try {
    if (!document.referrer) return null;
    const url = new URL(document.referrer);
    if (url.origin === window.location.origin) return null;
    return `${url.origin}${url.pathname}`.slice(0, 500);
  } catch {
    return null;
  }
}

export function collectVisitorInfo() {
  const ua = navigator.userAgent || "";
  let timeZone = null;
  try {
    timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone || null;
  } catch {
    // Intl unavailable - leave null
  }

  return {
    browser: detectBrowser(ua),
    os: detectOs(ua),
    deviceType: detectDeviceType(ua),
    screenWidth: window.screen?.width ?? null,
    screenHeight: window.screen?.height ?? null,
    language: (navigator.language || "").slice(0, 20) || null,
    timeZone,
    referrer: getExternalReferrer(),
    landingPath: `${window.location.pathname}`.slice(0, 500),
  };
}
